<script>
    import {getContext} from "svelte";
    import {get} from "svelte/store";
    import ChooseLocation from "./ChooseLocation.svelte";
    import PurchaseSteps from "./tfc/Purchase.svelte";
    import ChooseProduct from "./tfc/ChooseProduct.svelte";
    import ChoosePricing from "./b2b/ChoosePricing.svelte"
    import PurchaseComplete from "./PurchaseComplete.svelte"

    let {shopData, location, org, isGlobal} = getContext("SHOP");

    let currentStepIndex = 0;
    let update = true;

    const serviceProviderTypes = {
        Health: 'Doctor',
        Gym: 'Coach',
        'Tactical & First Responders': "Director"
    }

    export let currentStep;
    export let stepComplete = function(){
      currentStepIndex += 1;
      update = currentStepIndex;
      currentStep = steps[currentStepIndex];
    }

    let steps = [
      {
        title:"Couple/Individual",
        component:ChooseProduct,
        validate:function(){
          return $shopData.productType
        },
        result: function() {
            return `${!$shopData.productType ? 'Unknown' : $shopData.productType}`
        }
      }, {
        title:"Choose Plan",
        component:ChoosePricing,
        validate:function(){
          return $shopData.price && $shopData.payment_interval
        },
        result: function() {
            return `${!$shopData.tier ? 'Unknown' : $shopData.tier}`
        }
      },
      ...( !isGlobal ? [{
        title: `Choose ${serviceProviderTypes[org.type] || 'Coach'}`,
        component:ChooseLocation,
        validate:function(){
          return true
        },
        result: function() {
            return ($shopData.serviceProvider ? $shopData.serviceProvider.firstname + " " + $shopData.serviceProvider.lastname : 'Unknown')
        }
      }]: []), 
      {
        title:"User Details / Billing",
        component:PurchaseSteps,
        validate:function(){
          return $shopData.purchaseComplete
        },
        result: () => {}
      },{
        title:"Finalize Order",
        component:PurchaseComplete,
        validate:function(){
          return false
        },
        result:() => {}
      }
    ]

    // find the step we are on
    steps.some(s => {
      if(!s.validate()){
        currentStep = s
        return s
      }
    })

    function goToStep(i){
      if(currentStepIndex == 4) { // we finished the order.. dont allow them to move on
        return
      }
      // check if we are allowed to go to that step
      let stop = false;
      for(var j=currentStepIndex;j<i;j++){
        if(!steps[j].validate()) {
          stop = true;
          break;
        }
      }

      if(!stop){
        if(steps[i].validate()){
          currentStepIndex = update = i;
          currentStep = steps[i]
        }
      }

      console.log(i, currentStepIndex)

    }

</script>

<style type="text/scss">

  .complete {
    @apply bg-lime-400;

    .complete-check  {
      @apply text-lime-800
    }
  }

  .step {
    @apply bg-gray-300;

    &.active{
      @apply bg-white;
    }

    &.complete{
      @apply bg-lime-400;
    }
    &:hover{
      @apply bg-lime-500
    }
  }

  nav {
    width: 100%;
  }

  ol {
    width:100%;
    li {
      flex:1;
    }
    .step-title {
      @apply ml-4 text-sm
    }
    .progress-bar {
      @apply left-4 top-4 -ml-px mt-0.5 h-full w-0.5
    }
    @media screen and (max-width:800px){
      .details {
        display:none;
      }
    }
    @media screen and (max-width:1200px){
      display:flex;

      .progress-bar {
        width: 100%;
        height: 2px;
        left: 50%;
      }
      .step-group {
        flex-direction: column;
      }
      .step-title {
        text-align: center;
        @apply text-xs ml-0
      }
    }
  }
</style>
<nav aria-label="Progress">
  <ol role="list" class="overflow-hidden">
    {#key update}
      {#each steps as step ,i}
        <li class="relative cursor-pointer pb-10" on:click={e=>{goToStep(i)}}>
        {#if i !== steps.length-1 }
          <div class="progress-bar absolute  {currentStepIndex <= i ? 'bg-gray-300' :  'bg-lime-400'}" aria-hidden="true"></div>
        {/if}
          <!-- Complete Step -->
          <div class="step-group group relative flex items-center">
            {#if i === currentStepIndex && (currentStepIndex != steps.length-1)}
            <span class="flex h-9 items-center" aria-hidden="true">
              <span class="step active relative z-10 flex size-8 items-center justify-center rounded-full border-2 border-white">
                <span class="size-2.5 rounded-full bg-lime-400"></span>
              </span>
            </span>
            {:else if currentStepIndex > i || (currentStepIndex == steps.length-1)}
              <span class="flex h-9 items-center">
                <span class="step complete relative z-10 flex size-8 items-center justify-center rounded-full bg-lime-400">
                  <svg class="complete-check size-5 text-lime-800" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                    <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
                  </svg>
                </span>
              </span>
            {:else}
            <span class="flex h-9 items-center" aria-hidden="true">
              <span class="step relative z-10 flex size-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
                <span class="size-2.5 rounded-full bg-transparent group-hover:bg-gray-300"></span>
              </span>
            </span>
            {/if}

            <span class="step-title flex min-w-0 flex-col">
              <span class="font-medium">{step.title}</span>
              <span class="text-xs details">
                {#if step.result()}
                  {@html step.result()}
                {/if}
              </span>

            </span>
          </div>
        </li>
      {/each}
    {/key}
  </ol>
</nav>
